<template>
  <div class="agp-info" :style="style" :class="{ isLongLanguage }">
    <div class="legend">
      <div class="item">
        <div class="b1"></div>
        <div>50 % {{ $t('agpChart.median') }}</div>
      </div>
      <div class="item">
        <div class="b2"></div>
        <div>25 % - 75 % {{ $t('agpChart.interval') }}</div>
      </div>
      <div class="item">
        <div class="b3"></div>
        <div>10 % - 90 % {{ $t('agpChart.interval') }}</div>
      </div>
    </div>
    <div id="agp"></div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import reDrawTrigger from '@mx/reDrawTrigger'
import i18n from '@/i18n'

function getAgpOptions(
  data_10 = [],
  data_25 = [],
  data_50 = [],
  data_75 = [],
  data_90 = [],
  isMgDl = false,
  hyper = 10,
  hypo = 3.9,
  isToB = true
) {
  const intervalTime = data_10.length === 1440 ? 1 : 5
  const marklineObj = {
    symbol: 'none',
    data: [
      {
        silent: false, // 鼠标悬停事件  true没有，false有
        lineStyle: {
          type: 'dashed',
          color: '#ffaf00',
          width: 1
        },
        label: {
          show: isToB,
          formatter: `${i18n.t('unit.high')}`,
          distance: isMgDl ? [30, 0] : [27, 0]
        },
        yAxis: isMgDl ? (hyper * 18).toFixed(1) : hyper // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
      },
      {
        silent: false, // 鼠标悬停事件  true没有，false有
        lineStyle: {
          type: 'dashed',
          color: '#d4001a',
          width: 1
        },
        label: {
          show: isToB,
          formatter: `${i18n.t('unit.low')}`,
          distance: isMgDl ? [30, 0] : [27, 0]
        },
        yAxis: isMgDl ? (hypo * 18).toFixed(1) : hypo
      }
    ]
  }
  
  return {
    tooltip: {
      show: false,
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985'
        }
      }
    },
    grid: {
      x: isToB ? 20 : 75,
      y: 30,
      x2: isToB ? 100 : 20,
      y2: 30
    },
    xAxis: [
      {
        boundaryGap: false,
        type: 'time',
        splitLine: {
          show: false
        },
        min: +dayjs().startOf('day'),
        max: +dayjs().add(1, 'day').startOf('day'),
        splitNumber: 8,
        axisLabel: {
          showMaxLabel: true,
          formatter: function (value) {
            return dayjs(value).format('HH:mm')
          }
        }
      }
    ],
    yAxis: [
      {
        axisLine: {
          show: true
        },
        type: 'value',
        position: isToB ? 'right' : 'left',
        min: 0,
        max: isMgDl ? 450 : 25,
        interval: isMgDl ? 90 : 5
      }
    ],
    title: {
      subtext: isMgDl ? i18n.t('unit.mgdL') : i18n.t('unit.mmolL'),
      right: isToB ? 16 : 'auto',
      left: isToB ? 'auto' : -4,
      top: 9
    },
    animation: false,
    series: [
      {
        z: -1,
        name: '10%',
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 0
        },
        showSymbol: false,
        markLine: marklineObj,
        areaStyle: {
          opacity: 1,
          color: 'white'
        },
        data: data_10.map((c, i) => [
          +dayjs().startOf('day').add(intervalTime * i, 'minute'),
          c
        ])
      },
      {
        z: -2,
        name: '25%',
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 0
        },
        showSymbol: false,
        areaStyle: {
          opacity: 1,
          color: '#d2e1f2'
        },
        // markLine: marklineObj,
        data: data_25.map((c, i) => [
          +dayjs().startOf('day').add(intervalTime * i, 'minute'),
          c
        ])
      },
      {
        z: -3,
        name: '50%',
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 2,
          color: '#05367f'
        },
        areaStyle: {
          opacity: 1,
          color: '#7fa2d4'
        },
        showSymbol: false,
        // markLine: marklineObj,
        data: data_50.map((c, i) => [
          +dayjs().startOf('day').add(intervalTime * i, 'minute'),
          c
        ])
      },
      {
        z: -5,
        name: '75%',
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 0
        },
        showSymbol: false,
        areaStyle: {
          opacity: 1,
          color: '#7fa2d4'
        },
        // markLine: marklineObj,
        data: data_75.map((c, i) => [
          +dayjs().startOf('day').add(intervalTime * i, 'minute'),
          c
        ])
      },
      {
        z: -6,
        name: '90%',
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 0
        },
        showSymbol: false,
        label: {
          show: true,
          position: 'top'
        },
        areaStyle: {
          opacity: 1,
          color: '#d2e1f2'
        },
        // markLine: marklineObj,
        data: data_90.map((c, i) => [
          +dayjs().startOf('day').add(intervalTime * i, 'minute'),
          c
        ])
      }
    ]
  }
}  
export default {
  name: 'CgmAgp',
  mixins: [reDrawTrigger],
  props: {
    cgmRecord: {
      type: [Object],
      default: () => {
        return {
          eventMap: {},
          mage: [],
          num: [],
          mbg: [],
          maxbg: [],
          minbg: [],
          sdbg: [],
          pentagon: [],
          grade: {
            grade: 0
          },
          glucose: [],
          tir: {
            tir: []
          },
          lbgd28: [],
          lbgd39: [],
          lbgd100: [],
          lbgd139: [],
          lbgd222: []
        }
      }
    }
  },
  computed: {
    w() {
      const { ds, isLongLanguage } = this
      
      if (isLongLanguage) {
        return ds * (781 / 1740)
      } else {
        return ds * (750 / 1740)
      }
    },
    h() {
      const { w } = this
      
      if (w) {
        return (270 / 820) * w
      } else {
        return 300
      }
    },
    style() {
      const { w, h, zoomRatio, high, ds, isLongLanguage } = this
      const rst = { width: w + 'px', height: `${h}px`, zoom: zoomRatio }
      
      if (isLongLanguage) {
        rst['zoom'] = zoomRatio * 0.88
      }
      
      return rst
    }
  },
  mounted() {
    this.drawAgpChart()
  },
  methods: {
    drawAgpChart(isMgDl = false) {
      const agpChart = this.$echarts.init(document.getElementById('agp'), null, { renderer: 'svg' })
      try {
        agpChart.setOption(
          getAgpOptions(
            this.cgmRecord.dailyPrctile10 || [],
            this.cgmRecord.dailyPrctile25 || [],
            this.cgmRecord.dailyPrctile50 || [],
            this.cgmRecord.dailyPrctile75 || [],
            this.cgmRecord.dailyPrctile90 || [],
            isMgDl,
            this.cgmRecord.hyper,
            this.cgmRecord.hypo,
            this.isToB
          )
        )
      } catch (error) {
        console.error('被捕获:' + error)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.agp-info {
    #agp {
        /* width: calc(785 / 270 * 300px); */
        /* height: 300px; */
        width: 100%;
        height: calc(785 / 820 * 100%);
        /* transform: scale(0.9); */
        transform-origin: 0 0;
        margin-bottom: -40px;
    }
    .legend {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 10px;
        .item {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-right: 15px;
            font-size: 12px;
            
            .b1 {
                width: 30px;
                height: 2px;
                background-color: #05367f;
                margin-right: 5px;
            }
            .b2 {
                width: 30px;
                height: 15px;
                background-color: #7fa2d4;
                margin-right: 5px;
            }
            .b3 {
                width: 30px;
                height: 15px;
                background-color: #d2e1f2;
                margin-right: 5px;
            }
            .b4 {
                width: 30px;
                height: 8px;
          margin-right: 5px;
          border-top: 2px dashed #72b522;
          border-bottom: 2px dashed #72b522;
        }
      }
    }
  }
</style>
